export default "__VITE_ASSET__CkwVdA7l__"